'use client';

import { ReactNode } from 'react';

import { Container, Row, Rows, Section, TrilogyColor } from '@bytel/trilogy-react';

import { Faq } from '@components/faq';
import { Legals } from '@components/legals';
import { LetterVariant } from '@components/letter-variant';
import { SSIBlock } from '@components/ssi-block';
import { TriggerLogin } from '@components/trigger-login';

import { PAGE_SLUG, partials } from '@helpers/partials';

import { Breadcrumb } from './breadcrumb';

interface ProviderSimulatorProps {
    children: ReactNode;
}

export function ProviderSimulator({ children }: Readonly<ProviderSimulatorProps>) {
    return (
        <>
            <SSIBlock url={partials.MARKETING.PROMO_PRESENTATION} />
            {children}
            <Section backgroundColor={TrilogyColor.BACKGROUND}>
                <Container>
                    <SSIBlock url={partials.MARKETING.PROMO_STORYTELLING} />
                    <Rows gap={8}>
                        <Row>
                            <Faq
                                url={PAGE_SLUG.BIG_HOME}
                                title={
                                    <>
                                        Des questi
                                        <LetterVariant letter='o' />
                                        ns sur BiG&nbsp;?
                                        <br />
                                        On vous répond
                                    </>
                                }
                                titleAlt='Des questions sur BiG ? On vous répond'
                            />
                        </Row>
                        <Row>
                            <Breadcrumb />
                        </Row>
                        <Row className='ignore-sticky-scroll'>
                            <Legals id='mlBig-legals' url={PAGE_SLUG.BIG_HOME} />
                        </Row>
                    </Rows>
                </Container>
            </Section>
            <TriggerLogin />
        </>
    );
}
